// "Lincon Limit 14" → "Lincon Limit", "Brush 1 - South" → "Brush".
// Trailing numbers/directions are unit designators within one physical site.
// Hyphenated names without spaces (Rantoul-Hanger, St-Elmo) stay themselves.
const DESIGNATOR = /^(\d+|-|–|north|south|east|west|middle)$/i;

export function siteOf(name) {
  const toks = name.trim().split(/\s+/);
  while (toks.length > 1 && DESIGNATOR.test(toks[toks.length - 1])) toks.pop();
  return toks.join(' ');
}

export const naturalCompare = (a, b) => a.localeCompare(b, undefined, { numeric: true });

// [ [site, [member, ...]], ... ] alphabetical, members natural-sorted.
// getName maps an item to its location string (default: identity).
export function groupBySite(items, getName = x => x) {
  const map = new Map();
  for (const item of items) {
    const g = siteOf(getName(item));
    if (!map.has(g)) map.set(g, []);
    map.get(g).push(item);
  }
  return Array.from(map.entries())
    .sort((a, b) => naturalCompare(a[0], b[0]))
    .map(([g, members]) => [g, members.sort((a, b) => naturalCompare(getName(a), getName(b)))]);
}
